import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';
import { hasSensitiveDataSourceUrl } from './data-source-config-envelope';

@ValidatorConstraint({ name: 'isCredentialFreeDataSourceUrl', async: false })
export class IsCredentialFreeDataSourceUrl implements ValidatorConstraintInterface {
	validate(value: unknown): boolean {
		return typeof value !== 'string' || !hasSensitiveDataSourceUrl(value);
	}

	defaultMessage(arguments_: ValidationArguments): string {
		return `${arguments_.property} must not contain credentials or signed query parameters`;
	}
}
